import { environment } from '@environments/environment';
import { GeoFilterOptions } from '@shared/services/elastic-search/models';
import { LocalitySearch } from '@shared/services/locality-search/models';

export const GET_STORES_NEAR_COORDINATES_QUERY = (
  location: LocalitySearch,
  geoFilterOptions: GeoFilterOptions = {
    searchRadiusKm: 50,
    sort: 'asc',
  }
) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_store ?? '',
  body: {
    size: geoFilterOptions.searchRadiusKm === 50 ? 10000 : 3,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            exists: {
              field: 'uuid',
            },
          },
          {
            geo_distance: {
              distance: `${geoFilterOptions.searchRadiusKm}km`,
              latlon: {
                lat: location.coordinates!.lat,
                lon: location.coordinates!.lng,
              },
            },
          },
        ],
        must_not: [
          {
            geo_distance: {
              distance: '1m',
              latlon: {
                lat: 0.0,
                lon: 0.0,
              },
            },
          },
        ],
      },
    },
    sort: [
      {
        _geo_distance: {
          latlon: {
            lat: location.coordinates!.lat,
            lon: location.coordinates!.lng,
          },
          order: geoFilterOptions.sort,
          unit: 'km',
          distance_type: 'arc',
        },
      },
    ],
  },
});
